export default "__VITE_ASSET__DrEacl$n__"